
function getColors( selected ) {

  const bgFill = selected ? '#14816e' : 'rgba(0,0,0,0.12)';
  const iconFill = selected ? '#fff' : 'rgba(0,0,0,0.6)'
  const iconOpacity = selected ? '1' : '0.5'
  return { bgFill, iconFill, iconOpacity }
}
export function LandscapeIcon(props) {
  const { selected } = props;
  const { bgFill, iconFill, iconOpacity } = getColors( selected );
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" onClick={props.onClick}>
      <g id="Container">
        <rect width="35" height="35" rx="4" fill={bgFill}/>

      </g>
      <path id="photo_FILL0_wght400_GRAD0_opsz48" d="M11.65,19.479H23.358l-3.519-4.693-3.16,4.094L14.451,15.84ZM7.437,23.238A1.473,1.473,0,0,1,6,21.8V7.437A1.473,1.473,0,0,1,7.437,6H27.548a1.473,1.473,0,0,1,1.437,1.437V21.8a1.473,1.473,0,0,1-1.437,1.437Zm0-1.437H27.548V7.437H7.437V21.8Zm0-14.365h0V21.8h0V7.437Z" transform="translate(0.008 3.352)" fill={iconFill} opacity={iconOpacity}/>
    </svg>


  )
}
export function PortraitIcon(props) {
  const { selected } = props;

  const { bgFill, iconFill, iconOpacity } = getColors( selected );
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" onClick={props.onClick}>
      <g id="Container">
        <rect width="35" height="35" rx="4" fill={bgFill} />

      </g>
      <path id="photo_FILL0_wght400_GRAD0_opsz48" d="M1.415,16.978a1.357,1.357,0,0,1-.99-.424A1.357,1.357,0,0,1,0,15.563V1.415A1.357,1.357,0,0,1,.424.424,1.357,1.357,0,0,1,1.415,0H21.223a1.357,1.357,0,0,1,.99.424,1.357,1.357,0,0,1,.424.99V15.563a1.451,1.451,0,0,1-1.415,1.415Zm0-1.415H21.223V1.415H1.415V15.563Zm0-14.149h0V15.563h0V1.415Z" transform="translate(26 7) rotate(90)"  fill={iconFill} opacity={iconOpacity}/>
      <path id="photo_FILL0_wght400_GRAD0_opsz48-2" data-name="photo_FILL0_wght400_GRAD0_opsz48" d="M17.8,30.05H28.06l-3.084-5.7-2.77,4.973L20.255,25.63Z" transform="translate(-5.5 -5)"  fill={iconFill} opacity={iconOpacity}/>
    </svg>

  )
}